import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('@@xver/authPage');

export const setPhoneVerificationData = actionCreator<{
    phoneNumber: string;
    verificationToken: string;
}>('setPhoneVerificationData');

export const setEmailVerificationData = actionCreator<{
    emailAddress: string;
    verificationLevel: string;
    verificationToken: string;
}>('setEmailVerificationData');

export const set2FAData = actionCreator<{
    email: string;
    password: string;
}>('set2FAData');

export const resetAuthPageState = actionCreator<void>('resetAuthPageState');
